import { render, staticRenderFns } from "./gj-badge.vue?vue&type=template&id=49762994&scoped=true&"
import script from "./gj-badge.vue?vue&type=script&lang=js&"
export * from "./gj-badge.vue?vue&type=script&lang=js&"
import style0 from "./gj-badge.vue?vue&type=style&index=0&id=49762994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49762994",
  null
  
)

export default component.exports